import React, {useContext, useState} from 'react'
import {getAuthHeader, getPathBack, objectLang, removeCookieOfFolderId, setErrorWindow} from "../functions"
import {useHttp} from "../hooks/http.hook"
import {AuthContext} from "../context/AuthContext"
import config from "../config.json"
import {ModalWin} from "./ModalWin"
import {MenuCreateItemClass} from "../components/MenuCreateItemClass"
import {LoaderClass} from "./LoaderClass"

export const MenuCreateItemPage = ({documents}) => {

    let lang = objectLang().language
    const l = lang.lang
    const {request, loading} = useHttp()
    const auth = useContext(AuthContext)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    let host
    window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender

    const clickPasteFolderHandler = async (folderData, parentIdPaste, parentIdCut, isCutFolder) => {
        try {
            const data = await request(
                `${host}/api/folder/paste?folderId=${folderData.id}`,
                'POST',
                {parentFID: parentIdPaste},
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('',
                    data.code,
                    lang.messages[`code_${data.code}`],
                    lang.modal.errors.btnOK,
                    getPathBack())
                )
                window.location.replace(`/${l}/modal`)
            }
            if (data.status === 201) {
                localStorage.removeItem('copyFolder')
                removeCookieOfFolderId(parentIdPaste)
                removeCookieOfFolderId(parentIdCut)
                if (isCutFolder) {
                    window.location.replace(`/${l}/folder/remove/${folderData.id}`)
                } else {
                    window.location.replace(`/${l}/folder/open/${parentIdPaste}`)
                }
            }
            if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    const clickPasteLinkHandler = async (linkData, parentIdPaste, parentIdCut, isCutLink) => {
        try {
            const data = await request(
                `${host}/api/link/copy/${linkData.id}`,
                'POST',
                {parentFID: parentIdPaste},
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow(
                    '',
                    data.code,
                    lang.messages[`code_${data.code}`],
                    lang.modal.errors.btnOK, getPathBack())
                )
            }
            if (data.status === 201) {
                localStorage.removeItem('copyLink')
                removeCookieOfFolderId(parentIdPaste)
                removeCookieOfFolderId(parentIdCut)
                if (isCutLink) {
                    window.location.replace(`/${l}/link/remove/${linkData.id}`)
                } else {
                    window.location.replace(`/${l}/folder/open/${parentIdPaste}`)
                }
            }
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    const clickPasteNoteHandler = async (noteData, parentIdPaste, parentIdCut, isCutNote) => {
        try {
            const data = await request(
                `${host}/api/note/copy/${noteData.id}`,
                'POST',
                {parentFolder: parentIdPaste},
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow(
                    '',
                    data.code, lang.messages[`code_${data.code}`],
                    lang.modal.errors.btnOK,
                    getPathBack())
                )
            }
            if (data.status === 201) {
                localStorage.removeItem('copyNote')
                removeCookieOfFolderId(parentIdPaste)
                removeCookieOfFolderId(parentIdCut)
                if (isCutNote) {
                    window.location.replace(`/${l}/note/remove/${noteData.id}`)
                } else {
                    window.location.replace(`/${l}/folder/open/${parentIdPaste}`)
                }
            }
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    if (loading) {
        return <LoaderClass />
    }

    if (!allowed) {
        return <ModalWin data={dataModal}/>
    }

    return (
        <>
            {<MenuCreateItemClass
                lang={lang}
                auth={auth}
                documents={documents}
                clickPasteFolderHandler={clickPasteFolderHandler}
                clickPasteLinkHandler={clickPasteLinkHandler}
                clickPasteNoteHandler={clickPasteNoteHandler}
            />}
        </>
    )
}